import { tw } from "@sveabank/cc-common";
import type { Signer } from "../../types/signing";
import Card from "../card";
import CurrentSignerStatus from "./sign-status-current";
import SignStatusOther from "./sign-status-other";
import SignerInformation from "./signer-information";

type Props = {
	signer: Signer;
	signable?: false;
	isSigned: boolean;
	isSignStepCompleted?: boolean;
};

type SignableProps = {
	signer: Signer;
	signable: true;
	handleOpenSignModal: () => void;
	isFetchingAgreement: boolean;
	isSigned: boolean;
	isSignStepCompleted?: boolean;
};

const PackageSignBox = (props: Props | SignableProps) => {
	const { signer, signable, isSigned, isSignStepCompleted } = props;

	return (
		<Card fullWidth classNames={isSigned ? "bg-background-success" : "bg-background-secondary"}>
			<div
				className={tw(
					"tablet:flex-row tablet:justify-between flex grow flex-col items-center",
					isSigned && "flex-row justify-between",
				)}
			>
				{signable && !isSignStepCompleted ? (
					<>
						<SignerInformation signer={signer} />
						<CurrentSignerStatus
							accepted={signer.accepted}
							handleOpenSignModal={props.handleOpenSignModal}
							isFetchingAgreement={props.isFetchingAgreement}
							isSigned={isSigned}
						/>
					</>
				) : (
					<>
						<SignerInformation signer={signer} />
						<SignStatusOther
							accepted={signer.accepted}
							isSigned={isSigned}
							signStepCompleted={isSignStepCompleted}
						/>
					</>
				)}
			</div>
		</Card>
	);
};

export default PackageSignBox;
